import React, { useState } from 'react';
import TriggerDrawer from './TriggerDrawer';
import './Trigger.css';

const Trigger = ({ trigger, onUpdate }) => {
    const [showDrawer, setShowDrawer] = useState(false);

    const getTriggerText = (triggerType) => {
        if (!triggerType) {
            return 'Select trigger';
        }
        
        switch (triggerType) {
            case 'contact_added':
                return 'Contact Added';
            case 'contact_updated':
                return 'Contact Updated';
            case 'tag_added':
                return 'Tag Added';
            case 'tag_removed':
                return 'Tag Removed';
            case 'status_changed':
                return 'Status Changed';
            case 'text_message_received':
                return 'Text Message Received';
            case 'email_received':
                return 'Email Received';
            case 'specific_date_time':
                return 'On Specific Date and Time';
            default:
                return 'Unknown Trigger';
        }
    };

    const isTriggerConfigured = (trigger) => {
        if (!trigger.config.triggerType) {
            return false;
        }

        switch (trigger.config.triggerType) {
            case 'specific_date_time':
                return trigger.config.date && trigger.config.time && trigger.config.timezone;
            default:
                return true; // Other trigger types don't need additional configuration
        }
    };

    const getStatusText = (trigger) => {
        if (!trigger.config.triggerType) {
            return 'Pending';
        }
        
        if (!isTriggerConfigured(trigger)) {
            return 'Incomplete';
        }
        
        return 'Pending';
    };

    return (
        <>
            <div 
                className="trigger-block"
                onClick={() => setShowDrawer(true)}
            >
                <div className="trigger-content">
                    <div className="trigger-icon">
                        🔔
                    </div>
                    <div className="trigger-info">
                        <div className="trigger-title">Trigger</div>
                        <div className={`trigger-details ${!trigger.config.triggerType ? 'trigger-placeholder' : ''}`}>
                            {getTriggerText(trigger.config.triggerType)}
                        </div>
                    </div>
                    <div className="trigger-actions">
                        <div className={`trigger-status ${!isTriggerConfigured(trigger) ? 'trigger-incomplete' : ''}`}>
                            {getStatusText(trigger)}
                        </div>
                    </div>
                </div>
            </div>

            {showDrawer && (
                <TriggerDrawer 
                    trigger={trigger}
                    onUpdate={onUpdate}
                    onClose={() => setShowDrawer(false)}
                />
            )}
        </>
    );
};

export default Trigger; 